import { render, staticRenderFns } from "./PcStaticAddressValue.vue?vue&type=template&id=468e1a24"
import script from "./PcStaticAddressValue.vue?vue&type=script&lang=js"
export * from "./PcStaticAddressValue.vue?vue&type=script&lang=js"
import style0 from "./PcStaticAddressValue.vue?vue&type=style&index=0&id=468e1a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports